import { ChevronLeft, ChevronRight } from "lucide-react";
import BackfillPanel from "../components/BackfillPanel";
import SummaryStats from "../components/media/SummaryStats";
import SummaryFilters from "../components/media/SummaryFilters";
import SummaryTable from "../components/media/SummaryTable";
import SummaryDetailModal from "../components/media/SummaryDetailModal";
import useMediaSummariesList from "../components/media/useMediaSummariesList";
import useMediaBackfill from "../components/media/useMediaBackfill";
import useSummaryDetail from "../components/media/useSummaryDetail";

function PageHeader() {
  return (
    <div>
      <h1 className="text-2xl font-semibold text-[#0F1829]" style={{ fontFamily: "'Fraunces', serif" }}>
        Resumos do Media Center
      </h1>
      <p className="text-sm text-[#6B7280] mt-1">
        Geração automática de resumos (até 950 caracteres) para áudios e vídeos usando Whisper + Gemini 3 Flash.
      </p>
    </div>
  );
}

function Pagination({ page, totalPages, setPage }) {
  if (totalPages <= 1) return null;
  return (
    <div className="flex items-center justify-center gap-2 text-sm">
      <button onClick={() => setPage((p) => Math.max(1, p - 1))} disabled={page <= 1}
        className="px-3 py-1.5 border border-[#E6E1D6] rounded hover:bg-[#F5F2EB] disabled:opacity-40 inline-flex items-center gap-1"
        data-testid="ms-prev">
        <ChevronLeft size={14} /> Anterior
      </button>
      <span className="text-[#6B7280] text-xs">{page} / {totalPages}</span>
      <button onClick={() => setPage((p) => Math.min(totalPages, p + 1))} disabled={page >= totalPages}
        className="px-3 py-1.5 border border-[#E6E1D6] rounded hover:bg-[#F5F2EB] disabled:opacity-40 inline-flex items-center gap-1"
        data-testid="ms-next">
        Próxima <ChevronRight size={14} />
      </button>
    </div>
  );
}

export default function AdminMediaSummaries() {
  const list = useMediaSummariesList();
  const backfill = useMediaBackfill({ tipo: list.tipo, onFinished: list.load });
  const detail = useSummaryDetail({ onSaved: list.load });

  return (
    <div data-testid="admin-media-summaries" className="space-y-5">
      <PageHeader />
      <SummaryStats tipo={list.tipo} stats={list.data.stats} />
      <BackfillPanel
        backfill={backfill.backfill}
        backfillLimit={backfill.backfillLimit} setBackfillLimit={backfill.setBackfillLimit}
        backfillForce={backfill.backfillForce} setBackfillForce={backfill.setBackfillForce}
        backfillStarting={backfill.backfillStarting}
        startBackfill={backfill.startBackfill} stopBackfill={backfill.stopBackfill}
        remaining={(list.data.stats.grand_total || 0) - (list.data.stats.com_resumo || 0)}
      />
      <SummaryFilters
        tipo={list.tipo} setTipo={list.setTipo}
        hasResumo={list.hasResumo} setHasResumo={list.setHasResumo}
        q={list.q} setQ={list.setQ}
        setPage={list.setPage} onSearch={list.onSearch}
      />
      <SummaryTable
        items={list.data.items} loading={list.loading} tipo={list.tipo}
        processingIds={list.processingIds}
        onOpen={detail.open} onGenerate={list.generate}
      />
      <Pagination page={list.page} totalPages={list.totalPages} setPage={list.setPage} />
      <SummaryDetailModal
        detail={detail.detail} close={detail.close}
        editing={detail.editing} editForm={detail.editForm}
        updateEditField={detail.updateEditField}
        startEdit={detail.startEdit} cancelEdit={detail.cancelEdit}
        saving={detail.saving} save={detail.save}
        onRegenerate={list.generate}
        isRegenerating={detail.detail ? list.processingIds.has(detail.detail.id) : false}
      />
    </div>
  );
}
